module.exports = __webpack_public_path__ + "static/media/3.08593c65.png";